var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    stroke: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 15.803 13.922 C 15.929 14.047 16 14.218 16 14.396 C 16 14.573 15.929 14.744 15.803 14.869 L 14.869 15.803 C 14.744 15.929 14.573 16 14.396 16 C 14.218 16 14.047 15.929 13.922 15.803 L 8 9.881 L 2.078 15.803 C 1.953 15.929 1.782 16 1.604 16 C 1.427 16 1.256 15.929 1.131 15.803 L 0.197 14.869 C 0.071 14.744 0 14.573 0 14.396 C 0 14.218 0.071 14.047 0.197 13.922 L 6.119 8 L 0.197 2.078 C 0.071 1.953 0 1.782 0 1.604 C 0 1.427 0.071 1.256 0.197 1.131 L 1.131 0.197 C 1.256 0.071 1.427 0 1.604 0 C 1.782 0 1.953 0.071 2.078 0.197 L 8 6.119 L 13.922 0.197 C 14.047 0.071 14.218 0 14.396 0 C 14.573 0 14.744 0.071 14.869 0.197 L 15.803 1.131 C 15.929 1.256 16 1.427 16 1.604 C 16 1.782 15.929 1.953 15.803 2.078 L 9.881 8 L 15.803 13.922 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6150e4b5d00333e0c86d0baf48c37ce0.svg";
export { ForwardRef as ReactComponent };